import { MdOutlineContentCopy } from 'react-icons/md';
import { RiTwitterXFill } from 'react-icons/ri';
import { Drawer, DrawerContent } from '@/components/ui/drawer';
export default function Referral() {
  return <div className='flex flex-col lg:w-1/2 lg:flex-row gap-2 lg:gap-6 lg:mx-auto  px-5' data-sentry-component="Referral" data-sentry-source-file="Referral.tsx">
      <Drawer data-sentry-element="Drawer" data-sentry-source-file="Referral.tsx">
        <DrawerContent data-sentry-element="DrawerContent" data-sentry-source-file="Referral.tsx">
          <div className='p-8 flex flex-col gap-y-4 pb-[80px]'>
            <div className='text-genius-cream text-base/4'>Referral Link</div>
            <div className='text-sm text-genius-cream/70'>
              Earn 10% of the fees of everyone you refer and 5% of the fees of everyone they refer
            </div>
            <div className='flex p-2 rounded-[8px] justify-between items-center bg-genius-blue'>
              <p className='text-sm/4 text-genius-cream'>www.genius.trade/refer/unique-ID/23457</p>
              <MdOutlineContentCopy size={20} className='text-genius-pink' onClick={() => {
              navigator.clipboard.writeText('www.genius.trade/refer/unique-ID/23457');
            }} data-sentry-element="MdOutlineContentCopy" data-sentry-source-file="Referral.tsx" />
            </div>
            <div className='flex p-2 rounded-[8px] gap-x-2 items-center bg-genius-blue'>
              <RiTwitterXFill size={20} className='text-genius-cream' data-sentry-element="RiTwitterXFill" data-sentry-source-file="Referral.tsx" />
              <p className='text-sm/4 text-genius-cream'>
                Sign in and refer to X for a 2X multiple
              </p>
            </div>
          </div>
        </DrawerContent>
      </Drawer>
    </div>;
}